<template>
  <div class="py-20 bg-blackly relative">
    <div class="container">
      <h2 v-if="heading" class="fluid-3xl leading-none lg:mb-24 mb-16 text-center text-white" v-html="heading"></h2>
    </div>
    <CardSlider
      :breakpoints="breakpoints"
      :display-overflow="true"
      :arrows-inverted="true"
      :arrows-left="true"
      class="overflow-x-hidden"
    >
      <div v-for="(slide, index) in timelineSlides" :key="index" class="lg:pr-24 relative pr-12">
        <div class="gap-x-12 lg:grid-cols-2 gap-y-12 grid">
          <div class="text-br-green-light">
            <h3 v-if="slide.heading" class="fluid-3xl leading-none" v-html="slide.heading"></h3>
            <div v-if="slide.body" class="fluid-base leading-relaxed font-light mt-4" v-html="slide.body"></div>
          </div>
          <CldnImg
            v-if="slide.image[0]"
            :src="slide.image[0].url"
            :alt="slide.alt ? slide.alt : slide.image[0].title"
            sizes="50vw sm:50vw md:50vw lg:100vw xl:28vw 2xl:20vw"
            class="block select-none"
          />
        </div>
      </div>
    </CardSlider>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import CldnImg from '@/components/CldnImg';
import CardSlider from '@/components/common/CardSlider';

export default defineNuxtComponent({
  components: { CardSlider, CldnImg },
  props: {
    heading: {
      type: String,
      default: null,
    },
    timelineSlides: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      breakpoints: [
        {
          minWindowWidth: 0,
          slidesToShow: 1.6,
          slidesToScroll: 1,
        },
        {
          minWindowWidth: 768,
          slidesToShow: 1.1,
          slidesToScroll: 1,
        },
      ],
    };
  },
});
</script>
